module.exports = __webpack_public_path__ + "static/media/tobias-Flag-of-the-United-Kingdom.330b4363.svg";